export enum Connector {
  MetaMask = 'MetaMask',
  TrustWallet = 'TrustWallet',
  WalletConnect = 'WalletConnect',
  CoinbaseWallet = 'CoinbaseWallet',
  BinanceChainWallet = 'BinanceChainWallet',
  BraveWallet = 'BraveWallet',
  SafePal = 'SafePal',
}
